import { LeagueFieldBase, LeagueFieldTypes } from './league-field-base';
import { enumField, ModelInstance, ToBackHook, ToFrontHook } from './util';

@ModelInstance({
  mappingFields: {
    id: 'id',
    league_id: 'leagueId',
    name: 'name',
    type: 'type',
    is_multiple: 'isMultiple',
    variants: 'variants',
    sort: 'sort',
  },
  relation: {
    type: enumField(LeagueFieldTypes)
  }
})
export class LeaguePlayerField extends LeagueFieldBase {
  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
